module.exports = __webpack_public_path__ + "static/img/7areaA_02.42478ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_02.png
// module id = 1053
// module chunks = 1